import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/TTDragonTiger/tableBg.webp";
import welcome from "../images/TTDragonTiger/welcome.gif";
import ideal from "../images/TTDragonTiger/idle.gif";
import clapping from "../images/TTDragonTiger/clapping.gif";
import crown from "../images/TTDragonTiger/crown.png";
import closedCard from "../images/TTDragonTiger/closed-card.jpg";
import { cards } from "../images";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import GameAreaLoader from "../../Loader/GameAreaLoader";

export default function GameScreen({ onStageComplete, socketData, onAnimStart, onAnimEnd }) {
  const [animStage, setAnimStage] = useState("betting");
  const prevRoundRef = useRef(null);
  const isMountedRef = useRef(false);

const roundId = socketData?.roundId;
const settlement = socketData?.settlement;
const bettingClosed = socketData?.bettingClosed;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const mapCardStringToAsset = (cardCode) => {
    if (!cardCode || typeof cardCode !== "string") return closedCard;
    const raw = cardCode.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, "");
    if (cards[raw]) return cards[raw];
    if (cards[`${raw}.webp`]) return cards[`${raw}.webp`];
    return closedCard;
  };

  const getMainWinner = (outcome) => {
    if (!outcome) return "";
    const str = String(outcome).toUpperCase().trim();
    if (str.startsWith("DRAGON")) return "DRAGON";
    if (str.startsWith("TIGER")) return "TIGER";
    if (str === "TIE") return "TIE";
    return outcome;
  };


  const dragonCard = settlement?.dragonCard;
  const tigerCard = settlement?.tigerCard;
  const winner = settlement?.outcome;
  const currentRoundId = socketData?.roundId;


  const isIdle = settlement?.idle === true;
  const isWinner = settlement?.winner === true;
  const isClapping = settlement?.clapping === true;
const remainingTime = socketData?.remainingTime;
  // Naya round -> reset
  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
      prevRoundRef.current = currentRoundId;
      return;
    }
    if (currentRoundId && currentRoundId !== prevRoundRef.current) {
      prevRoundRef.current = currentRoundId;
      setAnimStage("betting");
      onAnimEnd?.();
    }
  }, [currentRoundId]);
const [showTiger, setShowTiger] = useState(false);

useEffect(() => {
  if (dragonCard && tigerCard) {
    setShowTiger(false);
    const t = setTimeout(() => setShowTiger(true), 2000);
    return () => clearTimeout(t);
  } else {
    setShowTiger(false);
  }
}, [dragonCard, tigerCard, roundId]);

useEffect(() => {
  if (!bettingClosed) {
    if (animStage !== "betting") setAnimStage("betting");
    return;
  }


  if (!dragonCard || !tigerCard) {
    if (isIdle) {
      if (animStage !== "revealing") {
        onAnimStart?.();
        setAnimStage("revealing");
      }
    }
   
    return;
  }


  if (isWinner && isClapping) {
    if (animStage !== "winner") setAnimStage("winner");
  } else {
    if (animStage !== "cards") setAnimStage("cards");
  }
}, [bettingClosed, isIdle, isWinner, isClapping, dragonCard, tigerCard]);


  useEffect(() => {
    if (animStage === "winner") {
      onStageComplete?.();
    }
   
  }, [animStage]);

  const showClosedCards = animStage === "revealing";
  const showWinner = animStage === "winner" && winner;

  const currentGif =
    animStage === "winner" ? clapping :
    animStage === "betting" ? welcome :
    ideal;

const dragonSrc = (bettingClosed && dragonCard) ? mapCardStringToAsset(dragonCard) : closedCard;
const tigerSrc  = (bettingClosed && tigerCard)  ? mapCardStringToAsset(tigerCard)  : closedCard;

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.gameContainer}>
        <div className={styles.mainGameArea}>
          <div className={styles.videoArea}>
            <div className={styles.videoContainer}>
              <img src={backgroundImage} alt="Dragon Tiger" className={styles.backgroundImage} draggable={false} />

              <div className={styles.gifOverlay}>
                <img src={currentGif} alt="Game Animation" className={styles.gifImage} draggable={false} />
              </div>

              <div className={styles.cardsContainer}>
                <div className={styles.dragonCard}>
                  <img src={dragonSrc} alt="Dragon Card" className={styles.cardImage} draggable={false} />
                  <span className={styles.cardLabel}>Dragon</span>
                </div>

                <div className={styles.tigerCard}>
                  <img src={tigerSrc} alt="Tiger Card" className={styles.cardImage} draggable={false} />
                  <span className={styles.cardLabel}>Tiger</span>
                </div>

                {showWinner && (
                  <div className={`${styles.winnerAnimation} ${styles[getMainWinner(winner).toLowerCase() + 'Winner']}`}>
                    <img src={crown} alt="Winner" className={styles.crownImage} />
                    <span className={styles.winnerText}>Winner: {getMainWinner(winner)}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {processingLoader  && (
      <div className={styles.dataProcessingOverlay}>
        <div className={styles.cardSpinner} />
      </div>
    )}
      </div>
    </GameAreaLoader>
  );
}